interface FaqItem {
  question: string
  answer: string
  sources?: Array<{ label: string }>
}

interface SeoReportWhatToKnowProps {
  title: string
  items: FaqItem[]
}

function FaqCard({ item }: { item: FaqItem }) {
  return (
    <div className='flex w-full flex-col gap-2 rounded-2xl border-[0.5px] border-border bg-ds-bg-secondary p-4'>
      <h3 className='text-balance text-base font-semibold leading-6 text-foreground'>
        {item.question}
      </h3>
      <p className='text-pretty text-sm leading-5 text-ds-text-quaternary'>
        {item.answer}
      </p>

      {item.sources && item.sources.length > 0 && (
        <div className='flex items-center gap-2'>
          <span className='text-xs font-medium leading-[18px] text-foreground-tertiary'>
            Sources:
          </span>
          {item.sources.map((source) => (
            <span
              key={source.label}
              className='rounded-full border-[0.5px] border-black/10 bg-white px-2 py-0.5 text-xs font-medium leading-[18px] text-foreground-tertiary'
            >
              {source.label}
            </span>
          ))}
        </div>
      )}
    </div>
  )
}

export function SeoReportWhatToKnow({
  title,
  items,
}: SeoReportWhatToKnowProps) {
  if (items.length === 0) return null

  return (
    <section className='flex flex-col gap-6'>
      <h2 className='font-display text-2xl font-bold text-foreground'>
        {title}
      </h2>

      <div className='flex flex-col gap-4'>
        <div className='flex flex-col gap-3'>
          {items.map((item) => (
            <FaqCard key={item.question} item={item} />
          ))}
        </div>
      </div>
    </section>
  )
}
